/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Cargando as Cargando,
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_Fo as Fo,
  rec_Gr as Gr,
  rec_JSXRuntime as JSXRuntime,
  rec_Lr as Lr,
  rec_NuevoProyecto as NuevoProyecto,
  rec_Oa as Oa,
  rec_Paginacion as Paginacion,
  rec_QC as QC,
  rec_Qx as Qx,
  rec_React as React,
  rec_Sn as Sn,
  rec_Ti as Ti,
  rec_Yx as Yx,
  rec_api as api,
  rec_nS as nS,
  rec_obtenerUsuario as obtenerUsuario,
} from "../../runtime/index.jsx";
export function Proyectos() {
  let { confirmar: e } = Fo(),
    [t, n] = (0, React.useState)([]),
    [r, i] = (0, React.useState)(0),
    [a, o] = (0, React.useState)(0),
    [s, c] = (0, React.useState)([]),
    [l, u] = (0, React.useState)(!0),
    [f, p] = (0, React.useState)(``),
    [m, h] = (0, React.useState)(!1),
    [g, _] = (0, React.useState)(``),
    [v, y] = (0, React.useState)([]),
    b = (0, React.useCallback)(async () => {
      (u(!0), p(``));
      try {
        let e = g === QC ? `&sinGrupo=true` : g ? `&grupo=${g}` : ``,
          [t, a, s] = await Promise.all([
            api(`/proyectos?pagina=${r}&tamano=24${e}`),
            api(`/grupos`),
            api(`/unidades?paraProyectos=true`),
          ]);
        (n(t.items),
          o(t.total),
          r > 0 && !t.items.length && i(r - 1),
          c(a),
          y(s));
      } catch (e) {
        p(e.message);
      } finally {
        u(!1);
      }
    }, [r, g]);
  (0, React.useEffect)(() => {
    b();
  }, [b]);
  let x = t;
  function S(e) {
    (_(e), i(0));
  }
  async function C(t, n) {
    if (
      (t.preventDefault(),
      t.stopPropagation(),
      await e({
        titulo: `Duplicar el proyecto`,
        mensaje: `Se copia la estructura de "${n.nombre}" (listas, etiquetas, metas y tareas) a un proyecto nuevo. No se copian miembros, asignados ni fechas.`,
        confirmarTexto: `Duplicar`,
      }))
    )
      try {
        let e = obtenerUsuario();
        (await api(`/proyectos/${n.id}/duplicar`, {
          method: `POST`,
          body: JSON.stringify({
            actorNombre: e?.nombre,
            actorCorreo: e?.correo,
          }),
        }),
          b());
      } catch (e) {
        p(e.message);
      }
  }
  return (
    <EstructuraPrincipal
      title={`Proyectos`}
      children={[
        <div
          className={`flex flex-col gap-6`}
          children={[
            <div
              className={`flex flex-wrap items-center justify-between gap-2`}
              children={[
                <p
                  className={`text-sm text-(--text)`}
                  children={`Proyectos donde participas.`}
                />,
                <button
                  type={`button`}
                  onClick={() => h(!0)}
                  className={`flex items-center gap-2 rounded-full bg-(--accent) px-4 py-2 text-sm font-medium text-(--accent-fg) transition hover:opacity-90`}
                  children={[<Ti className={`h-4 w-4`} />, ` Nuevo proyecto`]}
                />,
              ]}
            />,
            s.length > 0 && (
              <div
                className={`flex flex-wrap gap-1.5`}
                children={[
                  <button
                    type={`button`}
                    onClick={() => S(``)}
                    className={`rounded-full border px-3 py-1 text-xs font-medium ${g ? `border-(--border) text-(--text-h)` : `border-(--accent) bg-(--accent-bg) text-(--accent)`}`}
                    children={`Todos`}
                  />,
                  s.map((e) => (
                    <button
                      key={e.id}
                      type={`button`}
                      onClick={() => S(String(e.id))}
                      className={`rounded-full border px-3 py-1 text-xs font-medium ${g === String(e.id) ? `border-(--accent) bg-(--accent-bg) text-(--accent)` : `border-(--border) text-(--text-h)`}`}
                      children={e.nombre}
                    />
                  )),
                  <button
                    type={`button`}
                    onClick={() => S(QC)}
                    className={`rounded-full border px-3 py-1 text-xs font-medium ${g === QC ? `border-(--accent) bg-(--accent-bg) text-(--accent)` : `border-(--border) text-(--text-h)`}`}
                    children={`Sin grupo`}
                  />,
                ]}
              />
            ),
            <EstadoError mensaje={f} onReintentar={b} />,
            <Paginacion
              pagina={r}
              tamano={24}
              total={a}
              onChange={i}
              cargando={l}
            />,
            l ? (
              <Cargando
                variante={`tarjetas`}
                cantidad={6}
                etiqueta={`Cargando los proyectos`}
              />
            ) : x.length === 0 ? (
              <div
                className={`animar-entrada rounded-2xl border border-dashed border-(--border) p-10 text-center`}
                children={[
                  <Gr className={`mx-auto h-8 w-8 text-(--text)`} />,
                  <p
                    className={`mt-2 text-sm text-(--text)`}
                    children={`Todavia no tienes proyectos. Crea el primero.`}
                  />,
                ]}
              />
            ) : (
              <div
                className={`grid gap-4 sm:grid-cols-2 lg:grid-cols-3`}
                children={x.map((e) => (
                  <div
                    key={e.id}
                    className={`animar-entrada group relative rounded-2xl border border-(--border) bg-(--bg) transition hover:shadow-(--shadow)`}
                    children={[
                      <Sn
                        to={`/proyectos/${e.id}`}
                        onMouseEnter={() => Oa(`/proyectos/${e.id}`)}
                        onFocus={() => Oa(`/proyectos/${e.id}`)}
                        className={`block p-4`}
                        children={[
                          <div
                            className={`flex items-center gap-2 pr-6`}
                            children={[
                              <span
                                className={`h-3 w-3 shrink-0 rounded-full`}
                                style={{
                                  background: nS(e.color),
                                }}
                              />,
                              <h3
                                className={`min-w-0 flex-1 truncate font-medium text-(--text-h)`}
                                children={e.nombre}
                              />,
                            ]}
                          />,
                          e.descripcion && (
                            <p
                              className={`mt-2 line-clamp-2 text-sm text-(--text)`}
                              children={e.descripcion}
                            />
                          ),
                          <div
                            className={`mt-3 flex flex-wrap items-center gap-2`}
                            children={[
                              <span
                                className={`rounded-full px-2 py-0.5 text-xs ${Qx(e.estado)}`}
                                children={Yx(e.estado)}
                              />,
                              e.grupoNombre && (
                                <span
                                  className={`rounded-full bg-(--panel) px-2 py-0.5 text-xs text-(--text)`}
                                  children={e.grupoNombre}
                                />
                              ),
                              e.unidadNombre && (
                                <span
                                  className={`rounded-full bg-(--panel) px-2 py-0.5 text-xs text-(--text)`}
                                  title={e.unidadRuta}
                                  children={e.unidadNombre}
                                />
                              ),
                              <span
                                className={`text-xs text-(--text)`}
                                children={e.miRol && `Rol: ${Yx(e.miRol)}`}
                              />,
                            ]}
                          />,
                        ]}
                      />,
                      <button
                        type={`button`}
                        onClick={(t) => C(t, e)}
                        title={`Duplicar como plantilla`}
                        aria-label={`Duplicar proyecto`}
                        className={`absolute right-3 top-4 rounded-lg p-1 text-(--text) opacity-0 transition hover:bg-(--accent-bg) hover:text-(--accent) group-hover:opacity-100`}
                        children={<Lr className={`h-4 w-4`} />}
                      />,
                    ]}
                  />
                ))}
              />
            ),
          ]}
        />,
        m && (
          <NuevoProyecto
            grupos={s}
            areas={v}
            onClose={() => h(!1)}
            onCreado={b}
          />
        ),
      ]}
    />
  );
}
